import React, { Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Dashboard from "./Dashboard";
import ScreenedPatient from "./ScreenedPatient";
import TransactionLog from "./TransactionLog";
import ProfileUpdate from "./Profile";
import UserList from "./UserList";
import Create from "./Create";
import { LayoutSplashScreen } from "../../../_metronic";
import AddRoles from "./AddRoles";
import EditRoles from "./EditRoles";
import Roles from "./Roles";
import Privacy from "./Privacy";
import ChangePassword from "./ChangePassword";
import Logos from "./Logos";
import EditLogo from "./EditLogo";
import { connect } from "react-redux";

export const HomePage = (props) => {
  let permission = [];
  if (props.roles)
    props.roles.map(role => {
      if (props.roleName == "super-admin") {
        var index = props.roles.map(function (d) { return d['moduleName']; }).indexOf('list-users-limited');
        if (index == -1) {
          permission['list-users'] = true;
          permission['add-user'] = true;
          permission['edit-user'] = true;
          permission['list-roles'] = true;
          permission['add-role'] = true;
          permission['edit-role'] = true;
          permission['list-logos'] = true;
          permission['edit-logo'] = true;
          permission['transaction-log'] = true;
        }
        else {
          permission['list-users'] = true;
            if (props.roles.map(function (d) { return d['moduleName']; }).indexOf('add-user') != -1)
                permission['add-user'] = true;
            else if (props.roles.map(function (d) { return d['moduleName']; }).indexOf('edit-user') != -1)
                permission['edit-user'] = true;
            permission['transaction-log'] = true;
        }
      }
      else {
        var index = props.roles.map(function (d) { return d['moduleName']; }).indexOf('list-users-limited');
        if (index != -1) {
          permission['list-users'] = true;
            if (props.roles.map(function (d) { return d['moduleName']; }).indexOf('add-user') != -1)
            permission['add-user'] = true;
            else if (props.roles.map(function (d) { return d['moduleName']; }).indexOf('edit-user') != -1)
            permission['edit-user'] = true;
        }
        else
          permission[role.moduleName] = true;
      }
    })
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /dashboard. */
          <Redirect exact from="/" to="/dashboard" />
        }
        <Route path="/dashboard" component={Dashboard} />
        <Route path="/screened-patient" component={ScreenedPatient} />
        {permission['add-role'] == true &&
          <Route path="/role/add" component={AddRoles} />
        }
        {permission['edit-role'] == true &&
          <Route path="/role/edit" component={EditRoles} />
        }
        {permission['list-roles'] == true &&
          <Route path="/roles" component={Roles} />
        }
        {permission['list-users'] == true &&
          <Route exact={true} path="/users" component={UserList} />
        }
        {permission['add-user'] == true &&
          <Route path="/user/create" component={Create} />
        }
        {permission['edit-user'] == true &&
          <Route path="/user/edit/:userId" component={Create} />
        }
        {
          permission['transaction-log'] &&
          <Route path="/transaction-log" component={TransactionLog} />
        }
        <Route path="/users/update-profile" component={ProfileUpdate} />
        {/* <Route path="/privacy-policy" component={Privacy} firstLogin={true} /> */}
        {/* <Route path="/change-password" component={ChangePassword} firstLogin={true} /> */}

        {/* <Route
          path='/privacy-policy'
          render={(props) => (
            <Privacy {...props} firstLogin={true} />
          )}
        />
        <Route
          path='/change-password'
          render={(props) => (
            <ChangePassword {...props} firstLogin={true} />
          )}
        />*/}
        {
          permission['list-logos'] &&
          <Route path="/logos" component={Logos} />
        }
        {
          permission['edit-logo'] &&
          <Route path="/logo/edit" component={EditLogo} />
        }
        <Redirect to="/error/error-v1" />
      </Switch>
    </Suspense>
  );
}

function mapStateToProps(state) {
  return {
    roles: state.auth.modulelist || [],
    roleName: state.auth.user && state.auth.user.roleName ? state.auth.user.roleName : ''
  }
}

export default connect(
  mapStateToProps,
  null
)(HomePage);
